export default __webpack_public_path__ + "static/sizzle-05192f64ee073b1b39baed9078df0462.mp4";